// Bundles d3 v7 and exposes it as window.d3 for use by inline template
// scripts (community chart pages). Loading this bundle replaces the
// previous CDN script so the pages work fully offline.
import * as d3 from 'd3'

window.d3 = d3
